import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";
import { apiCaller } from "../../services/AxiosInstance";
import { SET_SYSTEM_CONFIG } from "./ActionTypes";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const NAVTOGGLE = "NAVTOGGLE";

export function signupAction(email, password, navigate) {
  return (dispatch) => {
    signUp(email, password)
      .then((response) => {
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(
          dispatch,
          response.data.expiresIn * 1000
          //history,
        );
        dispatch(confirmedSignupAction(response.data));
        navigate("/dashboard");
        //history.push('/dashboard');
      })
      .catch((error) => {
        const errorMessage = formatError(error.response.data);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}

export function Logout(navigate) {
  localStorage.removeItem("userDetails");
  localStorage.removeItem("systemconfigs");
  navigate("/login");

  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, navigate) {
  return (dispatch) => {
    apiCaller({
      method: "post",
      url: "auth/login",
      params: null,
      data: { email, password },
    })
      .then((response) => {
        const userData = response?.data?.data;

        if (!userData) {
          // If API didn't return valid user data
          const errorMessage = response?.data?.message || "Login failed";
          dispatch(loginFailedAction(errorMessage));
          return;
        }
        console.log(userData, "ueseirjfoeifjow");
        saveTokenInLocalStorage(response?.data?.data);
        // runLogoutTimer(dispatch, response.data.expiresIn * 1000, navigate);
        dispatch(loginConfirmedAction(response?.data?.data));
        localStorage.setItem("systemconfigs", JSON.stringify(response?.data?.data?.config));
        dispatch({ type: SET_SYSTEM_CONFIG, payload: response?.data?.data?.config });
        // navigate("/dashboard");
        // Redirect based on role
        if (userData?.user?.role?.title === "volunteers") {
          navigate("/audience");
        } else {
          navigate("/dashboard");
        }
      })
      .catch((error) => {
        const errorMessage = formatError(error?.response?.data);
        dispatch(loginFailedAction(errorMessage));
      });
  };
}

export function loginFailedAction(data) {
  // remove invalid token
  localStorage.removeItem("userDetails");
  localStorage.removeItem("systemconfigs");
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
export const navtoggle = () => {
  return {
    type: "NAVTOGGLE",
  };
};
